import Marquee from "react-fast-marquee";

export const Ribbon = () => {
  const items = ["Cinematographer", "Director", "Editor", "Photographer", "Educator"];
  return (
    <section data-testid="marquee-ribbon" className="py-10 border-y border-white/10 bg-[#050505]">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-head uppercase font-700 text-6xl sm:text-8xl tracking-tighter text-stroke mx-8">
              {item}
            </span>
            <span className="text-[#D90429] text-4xl">&#9679;</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
